import { CSSProperties } from "react";
import CardSymphony from "elements/CardSymphony";
import useWebsiteBuilder, { DividerStyle, WebsiteBuilder_dividerExists } from "Hooks/useWebsiteBuilder";
import { clsx, styx } from "modules/Utils";
import WebsiteBuilderHeader from "../WebsiteBuilderHeader";
import OptionsSymphony, { OptionItem } from "elements/OptionsSymphony";
import WebsiteBuilderFooter from "../WebsiteBuilderFooter";
import Colors from "modules/Colors";
import useScreen from "Hooks/useScreen";

interface DividerContentProps {
    className: string;
    contentIndex: number;
    tabSelectorComponent: React.ReactNode;
    id: string;
}

const DividerContent = ({
    className,
    contentIndex,
    tabSelectorComponent,
    id,
}: DividerContentProps) => {
    const {
        mobileView,
    } = useScreen();

    const {
        websiteContent,
        setWebsiteContent,
    } = useWebsiteBuilder() as WebsiteBuilder_dividerExists;

    const dividerContent = websiteContent[contentIndex].dividerContent;
    const dividerStyle = dividerContent.style;

    const requiresPaidPlan = true;

    const dividerSharedStyle = {
        width: 22,
        marginRight: 8,
    }

    const DIVIDER_STYLE_OPTIONS: OptionItem[] = [
        {
            id: DividerStyle.SOLID,
            label: 'Solid',
            childrenLeft: (
                <div
                    style={{
                        ...dividerSharedStyle,
                        borderTop: `2px solid ${dividerStyle === DividerStyle.SOLID ? Colors.purple : Colors.grey}`,
                    }}
                />
            )
        },
        {
            id: DividerStyle.DASHED,
            label: 'Dashed',
            childrenLeft: (
                <div
                    style={{
                        ...dividerSharedStyle,
                        borderTop: `2px dashed ${dividerStyle === DividerStyle.DASHED ? Colors.purple : Colors.grey}`,
                    }}
                />
            )
        },
        {
            id: DividerStyle.SOLID_PADDING,
            label: 'Solid Padding',
            childrenLeft: (
                <div
                    style={{
                        ...dividerSharedStyle,
                        borderTop: `2px solid ${dividerStyle === DividerStyle.SOLID_PADDING ? Colors.purple : Colors.grey}`,
                    }}
                />
            )
        },
        {
            id: DividerStyle.DASHED_PADDING,
            label: 'Dashed Padding',
            childrenLeft: (
                <div
                    style={{
                        ...dividerSharedStyle,
                        borderTop: `2px dashed ${dividerStyle === DividerStyle.DASHED_PADDING ? Colors.purple : Colors.grey}`,
                    }}
                />
            )
        },
    ]

    return (
        <CardSymphony
            id={id}
            className={clsx("videosContentComponent", className)}
            style={styx(sty.videosContentComponent)}
        >
            <WebsiteBuilderHeader
                contentIndex={contentIndex}
                // isDivider={!mobileView}
                isDivider={false}
                rightSideContent={tabSelectorComponent}
            />
            <WebsiteBuilderFooter
                contentIndex={contentIndex}
                isBorder={false}
                isTextColor
                requiresPaidPlan={requiresPaidPlan}
                titleRequired="The Divider content requires a paid plan to publish your website."
                styleOptions={
                    <OptionsSymphony
                        className="dividerStyleOptions"
                        style={{ flexWrap: 'wrap' }}
                        options={DIVIDER_STYLE_OPTIONS}
                        value={dividerContent.style}
                        handleOptionSelected={(option) => {
                            const updatedContent = [...websiteContent];
                            updatedContent[contentIndex].dividerContent.style = option as DividerStyle;
                            setWebsiteContent(updatedContent);
                        }}
                        size="small"
                        isRadio={false}
                        childrenLeftOffset={-8}
                    />
                }
            />
        </CardSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    videosContentCard: {
        padding: 16,
    },
    videosContentVideo: {
        width: '100%',
        height: 200,
        backgroundColor: 'red',
    }
}

export default DividerContent;